module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "pro-item relate"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("相似的作品")]), _vm._v(" "), _c('ul', {
    staticClass: "list-box clearfix"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("他的其他作品")]), _vm._v(" "), _c('ul', {
    staticClass: "list-box clearfix"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../images/application_detail/img-product.png")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-272b7618!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/relate.vue
// module id = 911n
// module chunks = 15